define([
	"dojo/_base/declare",
	"csi/wizard/ActionControllerMixin",
	"./NewStyleInGallery",
	"./_StyleWizardMixIn"
], function(declare, ActionControllerMixin, NewStyleInGallery, _StyleWizardMixIn) {

	return declare([NewStyleInGallery, ActionControllerMixin, _StyleWizardMixIn], {
		idWizardResource: "NewStyle",

		/**
		 * @override
		 * Allow user to Save & New
		 */
		_canRepeat: function() {
			return true;
		},
	});
});
